import { resolveTenantBusiness } from './resolveTenantBusiness';

export async function getEffectiveBusinessId(routeBusinessId) {
  if (routeBusinessId) return routeBusinessId;

  const tenantBusiness = await resolveTenantBusiness();

  return tenantBusiness?.id || null;
}
